export default {
    positions:undefined,
    positionOptions:[],
    importOptions:[],
    loading: false,
    error: null,
    errorShow: false
}